"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnualPay = AnnualPay;
exports.Beneficiary = Beneficiary;
exports.BirthDay = BirthDay;
exports.BurialCost = BurialCost;
exports.ChildcareCost = ChildcareCost;
exports.ChildrenAges = ChildrenAges;
exports.CollegeInflationRate = CollegeInflationRate;
exports.CollegePlanInd = CollegePlanInd;
exports.CollegeTerm = CollegeTerm;
exports.DependentAge = DependentAge;
exports.EarningsGrowthRate = EarningsGrowthRate;
exports.ExistingLifeInsurance = ExistingLifeInsurance;
exports.HealthcareCost = HealthcareCost;
exports.InflationRate = InflationRate;
exports.MortgageAmount = MortgageAmount;
exports.NumOfYearsReplacement = NumOfYearsReplacement;
exports.NumberOfChildren = NumberOfChildren;
exports.OtherDebtAmount = OtherDebtAmount;
exports.PartnerAge = PartnerAge;
exports.PersonalExpenses = PersonalExpenses;
exports.RateOfReturn = RateOfReturn;
exports.SavingAmount = SavingAmount;
exports.SpouseIncome = SpouseIncome;
exports.ZipCode = ZipCode;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _LifeInsuranceWizardCalc = require("./LifeInsuranceWizardCalc.config");
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _DropdownForForm = require("../Wizard/DropdownForForm");
var _parse = _interopRequireDefault(require("date-fns/parse"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// TEXT INPUT FIELDS START HERE
function BirthDay(props) {
  var {
    errors,
    touched,
    birthDay,
    birthMonth,
    birthYear,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = props;

  // Set birthdate field based on three separate, dependent fields
  _react.default.useEffect(() => {
    var parsedDate = (0, _parse.default)("".concat(birthMonth, "-").concat(birthDay, "-").concat(birthYear), 'M-d-y', new Date());
    setFieldValue('birthdate', parsedDate);
  }, [birthDay, birthMonth, birthYear, touched.birthdate, setFieldValue]);

  // Set birthdate touched after all three fields have been touched
  _react.default.useEffect(() => {
    setFieldTouched('birthdate', touched.birthMonth && touched.birthDay && touched.birthYear);
  }, [touched.birthDay, touched.birthMonth, touched.birthYear]);

  // Override errors in order sequential order
  _react.default.useEffect(() => {
    var firstBirthdateError = [errors.birthMonth, errors.birthDay, errors.birthYear, errors.birthdate].find(val => !!val);
    setFieldError('birthdate', firstBirthdateError);
  }, [errors.birthDay, errors.birthMonth, errors.birthYear, touched.birthDay, touched.birthMonth, touched.birthYear]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "li_birthMonth"
  }, "Birth Month"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    "aria-label": "li_birthMonth",
    name: "birthMonth",
    id: "li_birthMonth",
    placeholder: "MM",
    maxLength: "2",
    value: birthMonth,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, 'monthOfBirth').handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "li_birthDay"
  }, "Birth Day"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    "aria-label": "li_birthDay",
    id: "li_birthDay",
    name: "birthDay",
    placeholder: "DD",
    maxLength: "2",
    value: birthDay,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, 'dayOfBirth').handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "li_birthYear"
  }, "Birth Year"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    "aria-label": "li_birthYear",
    id: "li_birthYear",
    name: "birthYear",
    placeholder: "YYYY",
    maxLength: "4",
    value: birthYear,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, 'yearOfBirth').handleBlur()
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    className: "custom-feedback",
    type: "invalid"
  }, errors.birthdate)));
}
function ZipCode(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'zipCode';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "ZIP Code",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "Enter ZIP",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: _LifeInsuranceWizardCalc.popoverConfig.zipCode,
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function AnnualPay(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'annualPay';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Yearly Income to Replace",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "0",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function PartnerAge(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'partnerAge';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Spouse's Age",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "3",
    placeholder: "00",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function DependentAge(props) {
  // This component is almost a direct copy of PartnerAge, this just has a different label which is shown when a user
  // selects a 'family' value of 'a dependant adult'. We want to show different labels, even though the underlying formik field
  // is the same
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'dependentAge';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Dependant's Age",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "3",
    placeholder: "00",
    prepend: false,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function SpouseIncome(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'spouseIncome';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Spouse's Income",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "000,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: _LifeInsuranceWizardCalc.popoverConfig.spouseIncomeText,
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function ChildrenAges(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var {
    numOfKids
  } = values;
  var returnArray = [];
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: false,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur(fieldName) {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  for (var i = 0; i < numOfKids; i++) {
    var fieldName = "child".concat(i + 1, "Age");
    returnArray.push(/*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
      key: i,
      fieldName: fieldName,
      label: "Child ".concat(i + 1, " Age"),
      errors: errors,
      touched: touched,
      values: values,
      type: "text",
      inputMode: "numeric",
      maxLength: "3",
      placeholder: "00",
      prepend: false,
      append: false,
      onChange: generateOnChange(),
      onBlur: generateOnBlur(fieldName),
      id: _LifeInsuranceWizardCalc.idPrefix + fieldName
    }));
  }
  return returnArray;
}
function ChildcareCost(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'childCareCost';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Child Care Cost",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "000,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: _LifeInsuranceWizardCalc.popoverConfig.childcareText,
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function HealthcareCost(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'healthCareCost';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Health & Personal Care",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "000,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: _LifeInsuranceWizardCalc.popoverConfig.healthcareText,
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function MortgageAmount(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'mortgageAmount';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Mortgage",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "000,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function OtherDebtAmount(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'otherDebt';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Other Debts",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "000,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function BurialCost(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'burialCost';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Burial Cost",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    popoverText: _LifeInsuranceWizardCalc.popoverConfig.burialCostText,
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "000,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function PersonalExpenses(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'personalExpenses';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Monthly Personal Expenses of Salary",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    popoverText: _LifeInsuranceWizardCalc.popoverConfig.personalExpensesText,
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function SavingAmount(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'savingAmount';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Retirement or Other Savings",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "000,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function ExistingLifeInsurance(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'existingLifeInsurance';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Existing Life Insurance",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "10",
    placeholder: "000,000",
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function EarningsGrowthRate(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'earningsGrowthRate';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Salary Growth Rate",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "6",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: _LifeInsuranceWizardCalc.popoverConfig.earningsGrowthRateText,
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function InflationRate(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'inflationRate';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Inflation Rate",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: _LifeInsuranceWizardCalc.popoverConfig.inlfationRateText,
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function RateOfReturn(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'rateOfReturn';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Savings Growth Rate",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}
function CollegeInflationRate(props) {
  var {
    errors,
    touched,
    values
  } = props;
  var fieldName = 'collegeInflationRate';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_LifeInsuranceWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "College Inflation Rate",
    errors: errors,
    touched: touched,
    values: values,
    type: "text",
    inputMode: "numeric",
    maxLength: "5",
    placeholder: "00.00",
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    popoverText: _LifeInsuranceWizardCalc.popoverConfig.collegeInflationRateText,
    id: _LifeInsuranceWizardCalc.idPrefix + fieldName
  });
}

// DROPDOWNS START HERE
function Beneficiary(props) {
  var {
    values,
    setFieldValue
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    fieldName: "beneficiary",
    setFieldValue: setFieldValue,
    values: values,
    label: "Family",
    placeholderText: "Select One",
    dataArray: _LifeInsuranceWizardCalc.dropdownOptions.beneficiaryArray,
    calcName: _LifeInsuranceWizardCalc.calcName
  }));
}
function NumberOfChildren(props) {
  var {
    values,
    setFieldValue
  } = props;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    fieldName: "numOfKids",
    setFieldValue: setFieldValue,
    values: values,
    label: "Number Of Children",
    placeholderText: "Select One",
    dataArray: _LifeInsuranceWizardCalc.dropdownOptions.numOfKidsArray,
    calcName: _LifeInsuranceWizardCalc.calcName
  }));
}
function NumOfYearsReplacement(props) {
  var {
    values,
    setFieldValue
  } = props;
  var numOfYearsReplacementArray = [];
  for (var i = 1; i <= 30; i++) {
    var textPortion = 'Years';
    if (i == 1) {
      textPortion = 'Year';
    }
    numOfYearsReplacementArray.push("".concat(i, " ").concat(textPortion));
  }
  return /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    fieldName: "numOfYearsReplacement",
    setFieldValue: setFieldValue,
    values: values,
    label: "Income Replacement",
    placeholderText: "Select One",
    dataArray: numOfYearsReplacementArray,
    calcName: _LifeInsuranceWizardCalc.calcName
  });
}
function CollegeTerm(props) {
  var {
    values,
    setFieldValue
  } = props;
  return /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    fieldName: "collegeTerm",
    setFieldValue: setFieldValue,
    values: values,
    label: "College",
    placeholderText: "Select One",
    dataArray: _LifeInsuranceWizardCalc.dropdownOptions.collegeTermArray,
    calcName: _LifeInsuranceWizardCalc.calcName
  });
}
function CollegePlanInd(props) {
  var {
    values,
    setFieldValue
  } = props;
  return /*#__PURE__*/_react.default.createElement(_DropdownForForm.DropdownForForm, {
    fieldName: "collegePlanInd",
    setFieldValue: setFieldValue,
    values: values,
    label: "College Plan",
    placeholderText: "Select One",
    dataArray: _LifeInsuranceWizardCalc.dropdownOptions.planIndArray,
    calcName: _LifeInsuranceWizardCalc.calcName
  });
}